import { BrowserRouter, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import Login from './components/login';
import AdminLogin from './components/admin/login';
import { sessionStorageKey_session, themeColor } from './utils/constants';
import LayoutDashboard from './components/dashboard/layoutDashboard';
import Dashboard from './components/dashboard';
import { RegistryForm } from './components/login/registryForm';
import { useContext } from 'react';
import { GlobalContext } from './utils/globalContext';
import { Profile } from './components/profile';
import { ConfigProvider } from 'antd';
// import UsersManagement from './components/admin/users';
import { ClientsManagement } from './components/admin/clients';
import { InvoiceMonitor } from './components/admin/invoice';

const App = () => {
  const {
    menuRoutes: { paths }
  } = useContext(GlobalContext);
  return (
    <ConfigProvider theme={themeColor}>
      <BrowserRouter basename="/fb_sapo">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/admin_login" element={<AdminLogin />} />
          <Route path="/register" element={<RegistryForm />} />
          <Route path="/" element={<PrivateRoute element={<LayoutDashboard />} />}>
            <Route index element={<Dashboard />} />
            <Route path={'/profile'} element={<PrivateRoute element={<Profile />} />} />
            <Route path={'/client-list'} element={<PrivateRoute element={<ClientsManagement />} />} />
            {/* <Route path={'/user-list'} element={<PrivateRoute element={<UsersManagement />} />} /> */}
            <Route path={'/invoice-monitor'} element={<PrivateRoute element={<InvoiceMonitor />} />} />
            {paths.map((route, index) => {
              return <Route key={index} path={`/${route.path}`} element={<PrivateRoute element={route.element} />} />;
            })}
          </Route>
        </Routes>
      </BrowserRouter>
    </ConfigProvider>
  );
};

// Protected route components
const PrivateRoute = ({ element: Component }) => {
  const isAuthenticated = sessionStorage.getItem(sessionStorageKey_session);
  const location = useLocation();

  return isAuthenticated ? Component : <Navigate to="/login" state={{ from: location }} />;
};

export default App;
